// To use add select-all-group and select-all-target to div with checkbox
// Example: data-select-all-group="select_all_active" data-select-all-target="select_all_active_section"

// Then add select-all-group and select-all-item to the divs with checkboxes you want to select
// Example: data-select-all-group="select_all_active" data-select-all-item="select_all_active_section"
import _ from 'lodash';

const groupAttribute = 'data-select-all-group';
const itemAttribute = 'data-select-all-item';
export const targetAttribute = 'data-select-all-target';

export default class SelectAllSpecificCheckboxes {
  init = () => {
    const selectAllCheckbox = $(`[${targetAttribute}] input[type='checkbox']`);

    selectAllCheckbox.change((e) => this.selectAll(e.target));
  }

  selectAll = (targetCheckbox) => {
    const checkbox = $(targetCheckbox);
    const switcher = checkbox.closest(`[${groupAttribute}]`);
    const group = switcher.attr(groupAttribute);
    const target = switcher.attr(targetAttribute);

    const allCheckboxes = $(`[${groupAttribute}='${group}'][${itemAttribute}='${target}']`);

    this.check(allCheckboxes, targetCheckbox.checked);
  }

  check = (checkboxesSelector, checked) => {
    _.forEach($(checkboxesSelector), (checkbox) => { $(checkbox).find('[type=checkbox]').prop('checked', checked) });
  }
}
